module.exports = __webpack_public_path__ + "img/rot03.2691ac79.jpg";